import { CHART_COLORS } from "@/components/analytics/ChartCanvas";

export type ServiceTrendKey =
  | "billetterie"
  | "prestishop"
  | "commission"
  | "epargne"
  | "penalty"
  | "companyCommission";

export type ServiceTrendPoint = Record<ServiceTrendKey, number> & {
  bucket: string;
};

export const SERVICE_TREND_SERIES: Array<{
  key: ServiceTrendKey;
  label: string;
  color: string;
}> = [
  { key: "billetterie", label: "Billetterie", color: CHART_COLORS.primary },
  { key: "prestishop", label: "PrestiShop", color: CHART_COLORS.success },
  { key: "commission", label: "Commissions", color: CHART_COLORS.warning },
  { key: "epargne", label: "Épargne (frais)", color: "#6b5b95" },
  { key: "penalty", label: "Pénalités", color: CHART_COLORS.danger },
  { key: "companyCommission", label: "Commissions compagnies", color: "#0f766e" },
];
